import { CenteredWorkflowLayout, WorkflowHeader } from '@betterment/style-closet-react';
import { useNavigate } from 'react-router-dom';

import EmployerFourOhOneKContributions from './EmployerFourOhOneKContributions';
import FourOhOneKContributions from './FourOhOneKContributions';

import { WithLayout } from '../RetailApp/components/WithLayout';

const FourOhOneKContributionsWrapper: React.FC<React.PropsWithChildren> = () => {
  const navigate = useNavigate();

  const navigateToPreviousPage = () => {
    void navigate(-1);
  };

  return (
    <WithLayout parts={{ sidebar: false }}>
      <CenteredWorkflowLayout>
        <CenteredWorkflowLayout.Slot name="header">
          <WorkflowHeader title="401(k) contribution details" closeHandler={navigateToPreviousPage} />
        </CenteredWorkflowLayout.Slot>
        <CenteredWorkflowLayout.Slot name="content">
          <FourOhOneKContributions />
          <EmployerFourOhOneKContributions />
        </CenteredWorkflowLayout.Slot>
      </CenteredWorkflowLayout>
    </WithLayout>
  );
};

export default FourOhOneKContributionsWrapper;
